import React from "react"
import type { ReactNode } from "react"

type TitleBarProps = {
  content: ReactNode
}

export default function TitleBar({ content }: TitleBarProps) {
  if (typeof content === "string" || content instanceof String) {
    return (
      <h2 className="text-gray-800 text-lg leading-normal font-semibold">
        {content as string}
      </h2>
    )
  }

  return content as React.ReactElement | null
}
